import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ComplexWallItem } from '../../common/types/wall-item';

@Component({
  selector: 'app-cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.scss'],
})
export class CartItemComponent implements OnInit {
  @Input() cartItem!: ComplexWallItem;
  @Input() ethereumPrice!: number;

  @Output() removeHandler$: EventEmitter<string> = new EventEmitter();

  public price: number | undefined;

  constructor() {}

  ngOnInit(): void {
    this.price = this.cartItem.tiles.reduce(
      (price, tile) => price + (tile.price ?? 0),
      0
    );
  }
}
